import React from 'react';
import styles from './PermissionDenied.module.scss';

function PermissionDenied(props) {
  return (
    <div className={styles.denied}>
      <p>This retailer does not have permissions from any supplier.</p>
    </div>
  );
}

export default PermissionDenied;
